import '../assets/NcMentionBubble-BhiXWJv8.css';
import { generateUrl as c } from "@nextcloud/router";
/* empty css                                                                          */
import { n as u } from "./_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import { L as p } from "./Linkify-BaDLLFxP.mjs";
import m from "escape-html";
import a from "striptags";
import d from "vue";
const _ = {
  name: "NcMentionBubble",
  props: {
    id: {
      type: String,
      required: !0
    },
    /**
     * @deprecated Use `label` instead
     */
    title: {
      type: String,
      required: !1,
      default: null
    },
    label: {
      type: String,
      required: !1,
      default: null
    },
    icon: {
      type: String,
      required: !0
    },
    iconUrl: {
      type: [String, null],
      default: null
    },
    source: {
      type: String,
      required: !0
    },
    primary: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    avatarUrl() {
      return this.iconUrl ? this.iconUrl : this.id && this.source === "users" ? this.getAvatarUrl(this.id, 44) : null;
    },
    mentionText() {
      return !this.id.includes(" ") && !this.id.includes("/") ? "@".concat(this.id) : '@"'.concat(this.id, '"');
    },
    // Fallback to title for compatibility
    labelWithFallback() {
      return this.label || this.title;
    }
  },
  methods: {
    getAvatarUrl(t, e) {
      return c("/avatar/{user}/{size}", {
        user: t,
        size: e
      });
    }
  }
};
var b = function() {
  var e = this, r = e._self._c;
  return r("span", { staticClass: "mention-bubble", class: { "mention-bubble--primary": e.primary }, attrs: { contenteditable: "false" } }, [r("span", { staticClass: "mention-bubble__wrapper" }, [r("span", { staticClass: "mention-bubble__content" }, [r("span", { staticClass: "mention-bubble__icon", class: [e.icon, "mention-bubble__icon--".concat(e.avatarUrl ? "with-avatar" : "")], style: e.avatarUrl ? { backgroundImage: "url(".concat(e.avatarUrl, ")") } : null }), r("span", { staticClass: "mention-bubble__title", attrs: { role: "heading", title: e.labelWithFallback } })]), r("span", { staticClass: "mention-bubble__select", attrs: { role: "none" } }, [e._v(e._s(e.mentionText))])])]);
}, f = [], g = /* @__PURE__ */ u(
  _,
  b,
  f,
  !1,
  null,
  "9c74f2e0",
  null,
  null
);
const h = g.exports;
/**
 * @copyright Copyright (c) 2020 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const l = new RegExp("\\B(?<![^a-z0-9_\\-@.'\\s])").source, E = /(@[a-z0-9_\-@.']+)/.source, T = /@&quot;guest\/[a-f0-9]+&quot;/.source, y = /@&quot;(?:federated_)?(?:group|team|user){1}\/[a-z0-9_\-@.' /:]+&quot;/.source, $ = /@&quot;[a-z0-9_\-@.' ]+&quot;/.source, v = "(".concat(T, "|").concat(y, "|").concat($, ")"), C = new RegExp("".concat(l).concat(E), "gi"), N = new RegExp("".concat(l).concat(v), "gi"), z = {
  props: {
    userData: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    /**
     * Convert the value string to html for the inner content
     *
     * @param {string} value the content without html
     * @return {string} rendered html
     */
    renderContent(t) {
      return m(t).split(C).map((n) => n.split(N)).flat().map((n) => {
        if (!n.startsWith("@"))
          return p(n);
        const i = n.slice(1).replace(/&quot;/gi, "");
        return this.genSelectTemplate(i);
      }).join("").replace(/\n/gmi, "<br>").replace(/&amp;/gmi, "&");
    },
    /**
     * Convert the innerHtml content to a string with mentions as text
     *
     * @param {string} content the content without html
     * @return {string}
     */
    parseContent(t) {
      let e = t;
      return e = e.replace(/>\s+</g, "><"), e = e.replace(/<br>/gmi, "\n"), e = e.replace(/&nbsp;/gmi, " "), e = e.replace(/&amp;/gmi, "&"), e = e.replace(/<\/div>/gmi, "\n"), e = a(e, "<div>"), e = a(e), e;
    },
    /**
     * Generate an autocompletion popup entry template
     *
     * @param {string} value the value to match against the userData
     * @return {string}
     */
    genSelectTemplate(t) {
      if (typeof t > "u")
        return "".concat(this.autocompleteTribute.current.collection.trigger).concat(this.autocompleteTribute.current.mentionText);
      const e = this.userData[t];
      return e ? this.renderComponentHtml(e, h).replace(/[\n\t]/gmi, "") : [" ", "/", ":"].every((r) => !t.includes(r)) ? "@".concat(t) : '@"'.concat(t, '"');
    },
    /**
     * Render a component and return its html content
     *
     * @param {object} propsData the props to pass to the component
     * @param {object} component the component to render
     * @return {string} the rendered html
     */
    renderComponentHtml(t, e) {
      const r = d.extend(e), n = new r({
        propsData: t
      }), i = document.createElement("div"), s = document.createElement("div");
      i.style.display = "none", i.appendChild(s), document.body.appendChild(i), n.$mount(s);
      const o = i.innerHTML;
      return n.$destroy(), i.remove(), o;
    }
  }
};
export {
  h as N,
  C as U,
  N as a,
  z as r
};
